<template lang="pug">
  .lottery-scene-card-container
    img.card-tag(
      v-if="groupInfo.groupTag"
      :src="groupInfo.groupTag"
      alt=""
    )
    .card-header
      .card-title {{ groupInfo.groupName }}
    .card-body(
      v-if="groupInfo.prizeList && groupInfo.prizeList.length > 0"
    )
      .lottery-goods-item(v-for="item in groupInfo.prizeList")
        .item-img-area
          img.item-img(v-if="item.icon" :src="item.icon" alt="")
        .item-num-limit {{ item.dailyStock }}
        .item-name {{ item.prizeName }}
        .item-btn(
          :class="item.btnStyle"
          @click="handleBtnClick(item)"
        )
          img.btn-icon(
            v-if="item.isLocked"
            src="https://m.hellobike.com/resource/gallery/59/yGbfakIW-O.png"
            alt=""
          )
          .btn-text {{ item.btnName }}
</template>

<script>
export default {
  name: 'LotterySceneCard',
  props: {
    // 抽奖活动信息
    groupInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 抽奖按钮点击
    handleBtnClick(item) {
      this.$emit('lotteryClick', item);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../../styles/index.less';

.lottery-scene-card-container {
  position: relative;
  width: 1.76rem;
  height: 1.69rem;
  background-image: linear-gradient(25.17deg, #fff 44.3%, #fff7dc 97.81%);
  border-radius: 0.2rem;
  box-sizing: border-box;
  border: 0.02rem solid #fff;

  .card-tag {
    position: absolute;
    top: -0.15rem;
    left: 0;
    width: 0.576rem;
    height: 0.28rem;
  }

  .card-header {
    padding: 0.11rem 0.14rem 0;

    .card-title {
      font-weight: 700;
      font-size: 0.16rem;
      line-height: 0.21rem;
    }
  }

  .card-body {
    display: flex;
    justify-content: space-between;
    margin-top: 0.06rem;
    padding: 0 0.12rem;
  }

  .lottery-goods-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 0.7rem;
    height: 0.7rem;

    .item-img-area {
      flex-shrink: 0;
      overflow: hidden;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 0.08rem;
      background-color: #fff;

      .item-img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
        object-fit: contain;
      }
    }

    .item-num-limit {
      flex-shrink: 0;
      align-items: center;
      margin-top: -0.14rem;
      max-width: 0.7rem;
      padding: 0 0.04rem;
      height: 0.14rem;
      background-color: #fff2db;
      border-radius: 0.04rem;
      font-size: 0.1rem;
      line-height: 0.14rem;
      color: #392d27;
      .ellipsis();
    }

    .item-name {
      max-width: 0.7rem;
      flex-shrink: 0;
      margin-top: 0.04rem;
      line-height: 0.15rem;
      font-weight: 600;
      font-size: 0.11rem;
      .ellipsis();
    }

    .item-btn {
      position: relative;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.06rem;
      width: 0.66rem;
      height: 0.24rem;
      background-color: #fa4614;
      border-radius: 0.06rem;
      box-sizing: border-box;

      .btn-icon {
        position: absolute;
        top: -0.06rem;
        right: -0.03rem;
        width: 0.13rem;
        height: 0.15rem;
      }

      .btn-text {
        font-weight: 500;
        font-size: 0.12rem;
        line-height: normal;
        color: #fff;
        .ellipsis();
      }

      &.disabled {
        background-color: #fda185;
      }

      &.black {
        background-color: #242729;
      }

      &.grey {
        background-color: #bcc4cc;
      }
    }
  }
}
</style>
